module.exports = __webpack_public_path__ + "img/VA.afebadeb.png";